
import { useParams, useNavigate } from "react-router-dom";
import { ClassesManager } from "@/components/settings/admin/ClassesManager";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const GestionClases = () => {
  const { gymId } = useParams();
  const navigate = useNavigate();

  if (!gymId) {
    return <div className="text-primary">ID de gimnasio no válido</div>;
  }

  return (
    <div className="container pt-16 bg-background text-primary mx-auto py-6 space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate(-1)}
          className="text-primary hover:bg-primary/10"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-2xl font-bold text-primary">Gestión de Clases</h1>
      </div>
      <ClassesManager gymId={gymId} />
    </div>
  );
};

export default GestionClases;
